import React, { useState } from 'react';
import { isNormalOpt } from '../constants.js';

const SubjectiveSection = ({ section, formData, onChange, patternColor }) => {
  const [open, setOpen] = useState(false);

  const filledCount = section.fields.filter(f => {
    const v = formData[f.key];
    return Array.isArray(v) ? v.length > 0 : (v && v !== '');
  }).length;

  const abnormalCount = section.fields.filter(f => {
    const v = formData[f.key];
    if (Array.isArray(v)) return v.length > 0 && v.some(o => !isNormalOpt(o));
    return v && v !== '' && !isNormalOpt(v);
  }).length;

  const toggle = (key, opt, type) => {
    if (type === 'multi') {
      const curr = formData[key] || [];
      onChange(key, curr.includes(opt) ? curr.filter(o => o !== opt) : [...curr, opt]);
    } else {
      onChange(key, formData[key] === opt ? '' : opt);
    }
  };

  const sectionColor = section.color || patternColor;
  const isRedFlags = section.title === 'Red Flags';

  return (
    <div style={{ marginBottom: '10px' }}>
      {!open ? (
        <button type="button" onClick={() => setOpen(true)} style={{
          width: '100%', padding: '14px 18px', borderRadius: '14px',
          border: `2px dashed ${section.border}`,
          backgroundColor: section.bg, color: sectionColor,
          fontSize: '0.92rem', fontWeight: '700', cursor: 'pointer',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', transition: 'all 0.2s'
        }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>{section.icon}</span>
            <span>{section.title}</span>
          </span>
          <span style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
            {filledCount > 0 && abnormalCount === 0 && (
              <span style={{ fontSize: '11px', padding: '2px 10px', borderRadius: '20px', background: '#059669', color: '#fff', fontWeight: 800 }}>
                All normal
              </span>
            )}
            {abnormalCount > 0 && (
              <span style={{ fontSize: '11px', padding: '2px 10px', borderRadius: '20px', background: isRedFlags ? '#dc2626' : sectionColor, color: '#fff', fontWeight: 800 }}>
                {abnormalCount} finding{abnormalCount > 1 ? 's' : ''}
              </span>
            )}
            {filledCount === 0 && (
              <span style={{ fontSize: '11px', color: section.color, opacity: 0.6 }}>+ Add</span>
            )}
          </span>
        </button>
      ) : (
        <div style={{ borderRadius: '16px', border: `2px solid ${section.border}`, backgroundColor: section.bg, padding: '18px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
            <span style={{ fontWeight: '800', fontSize: '1rem', color: sectionColor, display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>{section.icon}</span><span>{section.title}</span>
            </span>
            <button type="button" onClick={() => setOpen(false)} style={{
              background: '#e2e8f0', border: 'none', borderRadius: '50%', width: '28px', height: '28px',
              cursor: 'pointer', fontWeight: '700', color: '#475569', fontSize: '1rem'
            }}>×</button>
          </div>

          {section.fields.map((field, fi) => {
            const val = formData[field.key];
            const selected = Array.isArray(val) ? val : (val ? [val] : []);
            const hasAbnormal = selected.some(o => !isNormalOpt(o));

            return (
              <div key={field.key} style={{
                marginBottom: fi < section.fields.length - 1 ? '14px' : 0,
                paddingBottom: fi < section.fields.length - 1 ? '14px' : 0,
                borderBottom: fi < section.fields.length - 1 ? `1px solid ${section.border}80` : 'none'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                  <span style={{ fontSize: '0.8rem', fontWeight: '700', color: '#475569' }}>{field.label}</span>
                  {selected.length > 0 && (
                    <span style={{
                      fontSize: '10px', fontWeight: '700', borderRadius: '8px', padding: '1px 7px',
                      background: hasAbnormal ? '#fef2f2' : '#ecfdf5',
                      color: hasAbnormal ? '#dc2626' : '#059669',
                      border: `1px solid ${hasAbnormal ? '#fca5a5' : '#6ee7b7'}`
                    }}>
                      {hasAbnormal ? 'Noted' : 'Normal'}
                    </span>
                  )}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                  {field.options.map(opt => {
                    const isActive = field.type === 'multi'
                      ? (formData[field.key] || []).includes(opt)
                      : formData[field.key] === opt;
                    const isNorm = isNormalOpt(opt);
                    return (
                      <button key={opt} type="button" onClick={() => toggle(field.key, opt, field.type)} style={{
                        padding: '5px 13px', borderRadius: '20px', fontSize: '0.78rem', fontWeight: '600',
                        cursor: 'pointer', transition: 'all 0.15s',
                        border: isActive ? `2px solid ${isNorm ? '#059669' : sectionColor}` : '2px solid #e2e8f0',
                        background: isActive ? (isNorm ? '#ecfdf5' : `${sectionColor}18`) : '#f8fafc',
                        color: isActive ? (isNorm ? '#065f46' : sectionColor) : '#64748b'
                      }}>{opt}</button>
                    );
                  })}
                </div>
              </div>
            );
          })}

          {filledCount > 0 && (
            <button type="button"
              onClick={() => section.fields.forEach(f => onChange(f.key, f.type === 'multi' ? [] : ''))}
              style={{ marginTop: '12px', padding: '5px 14px', borderRadius: '8px', border: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontSize: '0.75rem', fontWeight: '600', cursor: 'pointer' }}>
              Clear
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default SubjectiveSection;
